import { PrivateAxiosInstance } from './createAxiosInstance';
import { URLs } from '../constants/apiEndpoints';

// submit a new  post
export const submitPost = async (formData) => {
  await PrivateAxiosInstance.post(URLs.SUMBIT_POST, formData);
};

// fetch all post
export const fetchAllPosts = async ({ pageParam, id }) => {
  const queryParams = new URLSearchParams({
    page: pageParam,
    sortOrder: 'desc',
    sortBy: 'CreatedAt',
    search: id ? id : '',
    status: true,
  }).toString();

  const res = await PrivateAxiosInstance.get(
    `${URLs.GET_ALL_POST}?${queryParams}`
  );
  return res?.data?.posts;
};

//delete post
export const deletePost = async (postId) => {
  const res = await PrivateAxiosInstance.delete(
    `${URLs.DELETE_POST}/${postId}`
  );
  return res;
};

//getCommentById
export const getCommentById = async (postId) => {
  const queryParams = new URLSearchParams({ search: postId }).toString();
  const res = await PrivateAxiosInstance.get(
    `${URLs.GET_ALL_COMMENTS}?${queryParams}`
  );
  if (res.data?.comments < 0) {
    return;
  }
  return res.data?.comments;
};

//add comment
export const addComment = async ({ postId, comment, image }) => {
  const formData = new FormData();
  formData.append('files', image);
  formData.append('description', comment);
  formData.append('postId', postId);

  const res = await PrivateAxiosInstance.post(
    URLs.ADD_COMMENTS_TO_POST,
    formData
  );
  return res;
};

//add comment
export const addCommentForComment = async ({
  postId,
  parentId,
  commentText,
  file,
}) => {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('description', commentText);
  formData.append('parentId', parentId);
  formData.append('postId', postId);

  const res = await PrivateAxiosInstance.post(
    URLs.ADD_COMMENTS_TO_POST,
    formData
  );
  return res;
};

//approved topic
export const deleteComment = async (id) => {
  const res = await PrivateAxiosInstance.delete(
    `${URLs.ADD_COMMENTS_TO_POST}/${id}`
  );
  return res?.data;
};

//add like
export const addLike = async ({ postId, like }) => {
  const res = await PrivateAxiosInstance.post(
    `${URLs.ADD_LIKE}/${postId}/${like}`
  );
  return res;
};

//edit post
export const updatePost = async ({ postId, formData }) => {
  const res = await PrivateAxiosInstance.post(
    `${URLs.SUMBIT_POST}/${postId}`,
    formData
  );
  return res;
};

// fetch all artiles
export const getAllArticles = async ({ page }) => {
  const queryParams = new URLSearchParams({
    page: String(page),
    limit: '12',
    sortOrder: 'desc',
    status: true,
  }).toString();

  const res = await PrivateAxiosInstance.get(
    `${URLs.GET_ALL_ARTICLES}?${queryParams}`
  );
  return res?.data;
};

// fetch all artiles
export const getArticleById = async (id) => {
  const res = await PrivateAxiosInstance.get(`${URLs.GET_ALL_ARTICLES}/${id}`);
  return res?.data?.article;
};

//add topics
export const addTopic = async (formData) => {
  const res = await PrivateAxiosInstance.post(URLs.TOPICS_URL, formData);
  return res;
};

//get all topics
export const getAllTopics = async ({ pageParam, selectedKeys }) => {
  const queryParams = new URLSearchParams({
    page: pageParam,
    sortOrder: 'desc',
    approvalStatus: selectedKeys,
  }).toString();

  const res = await PrivateAxiosInstance.get(
    `${URLs.TOPICS_URL}?${queryParams}`
  );
  return res?.data?.topics;
};

//get topic by id
export const getTopicById = async (id) => {
  const res = await PrivateAxiosInstance.get(`${URLs.TOPICS_URL}/${id}`);
  return res?.data?.topic;
};

//approved topic
export const approveTopic = async (id) => {
  const res = await PrivateAxiosInstance.put(
    `${URLs.TOPICS_URL}/${id}/approved`
  );
  return res?.data;
};

//approved topic
export const deletetopic = async (id) => {
  const res = await PrivateAxiosInstance.delete(`${URLs.TOPICS_URL}/${id}`);
  return res?.data;
};
